<span appAddClassModifier class="page-loading-indicator"></span>
